/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Button as NuiButton } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

const Button = forwardRef(({
  messageProps = {},
  messageId = messageProps.id,
  children,
  size,
  className,
  variant,
  round = !!variant && variant !== 'default' && variant !== 'link',
  ...rest
}, ref) => (
  <NuiButton
    ref={ref}
    round={round}
    variant={variant}
    size={size === 'xlTall' ? 'xlarge' : size}
    className={cx(className, size === 'xlTall' && 'nui-button--xlTall')}
    {...rest}
  >
    {messageId ? <FormattedMessage {...messageProps} id={messageId} /> : children}
  </NuiButton>
))

Button.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['tiny', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xlTall']),
  messageId: PropTypes.string,
  messageProps: PropTypes.shape({ id: PropTypes.string }),
  round: PropTypes.bool,
  variant: PropTypes.string,
}

export default Button
